import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import logo from "../assets/logo-avellaneda.png";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

function Appbar() {
  const classes = useStyles();
  return (
    <AppBar position="sticky" className={classes.appBar}>
      <Toolbar>
        <div style={{ width: "30%", padding: 10 }}>
          <img src={logo} style={{ width: "10rem" }} />
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default Appbar;